import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'

import {useBooking} from '@/stores/booking'
import {useDevice} from '@/stores/device'

export const useConfig = defineStore('config', () => {
  const deviceStore = useDevice();
  const bookingStore = useBooking();

  const config = ref(false)
  const account = ref(false)
  const loading = ref(true)
  const account_slug = ref('')
  const appointment = ref({})
  
  async function get(){
    try{

      const urlParams = new URLSearchParams(window.location.search);

      const token_from_url = urlParams.get('token');

      var appointment_token = token_from_url;
      if(!appointment_token) appointment_token = deviceStore.appointment_token;

      if(!appointment_token) appointment_token = '';
      else appointment_token = '/' + appointment_token;

      if(deviceStore.device_token) axios.defaults.headers.PrenotAIDeviceToken = deviceStore.device_token;

      try{
        var response = await axios.get('/config' + appointment_token);
        const appt = response.data.appointment;
        const is_closed = appt && (appt.confirmed_at || appt.booking_state === 'confirmed') && appt.is_paid;

        if(!token_from_url && is_closed){
          deviceStore.appointment_token = null;
          response = await axios.get('/config');
        }

        config.value = response.data.config;

        config.value.booking_steps.push('booking');
        config.value.booking_steps.push('confirm');

        account.value = response.data.account;

        if(response.data.device_token){
          deviceStore.device_token = response.data.device_token;
          axios.defaults.headers.PrenotAIDeviceToken = deviceStore.device_token;
        }
        await bookingStore.setAppointment(response.data.appointment);
        
        window.document.documentElement.style.setProperty('--color-primary', config.value.theme.color_primary);
        window.document.documentElement.style.setProperty('--color-primary-light', config.value.theme.color_primary_light);
        window.document.documentElement.style.setProperty('--color-primary-dark', config.value.theme.color_primary_dark);
        window.document.documentElement.style.setProperty('--bg-active', config.value.theme.bg_active);
        window.document.documentElement.style.setProperty('--text-active', config.value.theme.text_active);

        loading.value = false;

        if(!bookingStore.appointment.confirmed) bookingStore.track();
        
      }catch(e){
        if(e.status == '404'){
          window.document.documentElement.style.setProperty('--color-primary', '#3c62f9');
          window.document.documentElement.style.setProperty('--color-primary-light', '#d3e6ff');
          window.document.documentElement.style.setProperty('--color-primary-dark', '#3c5fed');
          window.document.documentElement.style.setProperty('--bg-active', '#40c3f7');
          window.document.documentElement.style.setProperty('--text-active', 'rgba(0,0,0,0.8)');
        }else throw e;
      }

      
    }catch(e){
      //window.document.querySelector('.view-main').style.display = 'none';
      console.log(e);
    }
  }

  return { 
    config,
    account,
    get,
    loading,
    account_slug,
    appointment
  }

})